import { describe, expect, it } from '@jest/globals';
import { sortGeneratedConfig } from './sortGeneratedConfig.js';
import type { GeneratedConfig } from '@ms-cloudpack/common-types';

describe('sortGeneratedConfig', () => {
  it('handles an empty GeneratedConfig', () => {
    const input: GeneratedConfig = { packageSettings: [] };
    sortGeneratedConfig(input);
    expect(input).toEqual({ packageSettings: [] });
  });

  it('sorts packageSettings', () => {
    const input: GeneratedConfig = {
      packageSettings: [{ match: { name: 'b', version: '1.0.0' } }, { match: { name: 'a', version: '1.0.0' } }],
    };
    sortGeneratedConfig(input);
    expect(input).toEqual({
      packageSettings: [{ match: { name: 'a', version: '1.0.0' } }, { match: { name: 'b', version: '1.0.0' } }],
    });
  });

  it('sorts packageSettings values', () => {
    const input: GeneratedConfig = {
      packageSettings: [
        {
          match: { name: 'a', version: '1.0.0' },
          includedDependencies: ['b', 'a', 'c'],
          exports: { './b.js': './b.js', './a.js': './a.js' },
        },
      ],
    };
    sortGeneratedConfig(input);
    expect(input).toEqual({
      packageSettings: [
        {
          match: { name: 'a', version: '1.0.0' },
          exports: { './a.js': './a.js', './b.js': './b.js' },
          includedDependencies: ['a', 'b', 'c'],
        },
      ],
    });
  });
});
